import { Component } from '@angular/core';

@Component({
  selector: 'app-block-overlay',
  imports: [],
  templateUrl: './block-overlay.component.html',
  styleUrl: './block-overlay.component.scss'
})
export class BlockOverlayComponent {

}
